var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00a9ce",
    fillOpacity: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.99,10.53c3.79,0,7.17,2.13,8.82,5.5-.59,1.22-1.42,2.27-2.41,3.12l1.41,1.41c1.39-1.23,2.49-2.77,3.18-4.53-1.73-4.39-6-7.5-11-7.5-1.27,0-2.49.2-3.64.57l1.65,1.65c.65-.13,1.31-.22,1.99-.22ZM14.92,11.67l2.07,2.07c.57.25,1.03.71,1.28,1.28l2.07,2.07c.08-.34.14-.7.14-1.07.01-2.48-2.01-4.49-4.49-4.49-.37,0-.72.05-1.07.14ZM6,8.4l2.68,2.68c-1.63,1.28-2.92,2.98-3.69,4.95,1.73,4.39,6,7.5,11,7.5,1.52,0,2.98-.29,4.32-.82l3.42,3.42,1.41-1.41L7.41,6.98l-1.41,1.42ZM13.5,15.9l2.61,2.61s-.08.02-.12.02c-1.38,0-2.5-1.12-2.5-2.5,0-.05.01-.08.01-.13ZM10.1,12.5l1.75,1.75c-.23.55-.36,1.15-.36,1.78,0,2.48,2.02,4.5,4.5,4.5.63,0,1.23-.13,1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79,0-7.17-2.13-8.82-5.5.7-1.43,1.72-2.61,2.93-3.53Z",
    fill: "white",
    strokeWidth: "0px"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_1590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hide_password_icon.a06beb4ccc5e93842ec48dce31b28b94.svg";
export { ForwardRef as ReactComponent };